import React from 'react';
import { useSelector } from 'react-redux';
import { selectClientPublicInfoSelector } from 'redux/selectors';
import { useNavigate } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

import { responsiveBreakpoints } from 'utils/utils';
import { isEmpty } from 'lodash';
import { PublicScreen } from 'routes/screen-names';

const Header2Public = () => {
  const clientPublicInfo = useSelector(selectClientPublicInfoSelector);
  const navigate = useNavigate();
  const { theme, mobile, tablet, laptop, desktop, mainWidth } =
    responsiveBreakpoints();
  return (
    <AppBar
      position='static'
      sx={[
        {
          height: '82px',
          backgroundColor: 'var(--paper-background-color)',
          boxShadow: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0px',
          borderBottom: '1px solid var(--primary-border-color)',
        },
      ]}
    >
      <Toolbar
        disableGutters
        sx={{
          justifyContent: 'space-between',
          width: mainWidth,
        }}
      >
        <Tooltip
          title={clientPublicInfo?.logo_alt_text}
          placement='right-end'
          sx={{
            backgroundColor: 'red',
            color: 'red',
          }}
        >
          <a
            onClick={() => {
              navigate('/');
              location.reload();
            }}
            style={{ cursor: 'pointer' }}
          >
            {!isEmpty(clientPublicInfo) && (
              <img
                src={clientPublicInfo?.media?.logo}
                alt='logo'
                style={{ maxWidth: '300px', maxHeight: '50px' }}
              />
            )}
          </a>
        </Tooltip>

        <Stack
          direction='row'
          alignItems='center'
          spacing={2}
          sx={{ position: 'relative' }}
        >
          {clientPublicInfo?.new_account_text_button ? (
            <Button
              variant='outlined'
              size={mobile ? 'small' : 'medium'}
              sx={mobile ? { padding: '10px 8px' } : { padding: '10px 26px' }}
              onClick={() => navigate(PublicScreen.register)}
            >
              {clientPublicInfo?.new_account_text_button}
            </Button>
          ) : null}

          <Button
            variant='contained'
            size={mobile ? 'small' : 'medium'}
            sx={{ padding: '10px 26px' }}
            onClick={() => navigate(PublicScreen.login)}
          >
            Login
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Header2Public;
